export const DataReviewColumnConst = [
    'columnId',
    'dataField',
    'denominatorField',
    'heading',
    'level',
    'numeratorField',
    'table',
    'type',
    'dataSource',
    'panelField',
    'panelId',
];
